module.exports = __webpack_public_path__ + "img/bgk.d015a712.jpg";